/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, DateField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './LicenseTableComponent.module.scss';
import metadata from './LicenseTableComponent.metadata.json5';

function LicenseTableComponent(props) {

    const {
        data: LicenseTableVM,
        updateWizardData,
        submissionVM,
        LicenseTablePath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addLicenseTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            LicenseTableVM.value = LicenseTableVM.value || []

            const { _xCenter, _dtoName } = LicenseTableVM;

            const LicenseTableObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            LicenseTableObjVM.isValidationReq = true;

            LicenseTableVM.pushElement(
                LicenseTableObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, LicenseTableVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            LicenseTableVM.value.splice(index, 1);
            _.set(submissionVM.value, LicenseTablePath, LicenseTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, LicenseTablePath, LicenseTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'number') {
                const licenseArray = _.get(submissionVM.value, LicenseTablePath);
                const newNumber = licenseArray?.length >= 2 ? licenseArray[licenseArray.length - 2].number + 1 : index + 1;

                if (licenseArray[index].number === undefined) {
                    licenseArray[index].number = newNumber;
                    _.set(submissionVM.value, LicenseTablePath, LicenseTableVM.value);
                }

                const value = item.number ? item.number : newNumber;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'nam2') {
                const value = item.nam2 ? item.nam2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.nam2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'licNum3') {
                const value = item.licNum3 ? item.licNum3 : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.licNum3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'datLic4') {
                const value = item.datLic4 ? item.datLic4 : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={(val, changedPath) => {
                            item.datLic4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }


        }, [LicenseTablePath, LicenseTableVM?.value, handleValueChange, submissionVM?.value])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`LicenseTableTable`]: {
            data: LicenseTableVM.value,
        }

    }), [LicenseTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addLicenseTable,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            LicenseTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [LicenseTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={LicenseTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

LicenseTableComponent.propTypes = wizardProps;
export default withRouter(LicenseTableComponent);
